import { css, styled, Theme } from '@mui/material/styles';
import { Image, Typography } from 'core/common/ui/ui-kit';

export type CardAchievementVariant = 'accent' | 'main';

const getBackgroundColor = (variant: CardAchievementVariant, theme: Theme, isMobile: boolean) => {
  const variantStyles = {
    main: {
      desktop: theme.palette.background.mainBodyDesktop,
      mobile: theme.palette.background.mainBodyMobile,
    },
    accent: {
      desktop: theme.palette.cardAchievement.accentBodyDesktop,
      mobile: theme.palette.cardAchievement.accentBodyMobile,
    },
  };

  return isMobile ? variantStyles[variant].mobile : variantStyles[variant].desktop;
};

export const CardWrapperStyled = styled('div')`
  width: 100%;
  padding: 2px;
  border-radius: 20px;
  background: ${({ theme }) => theme.palette.cardAchievement.border};
`;

export const CardStyled = styled('div')<{ variant: CardAchievementVariant }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 12px 16px;
  border-radius: 18px;

  ${({ variant, theme }) => css`
    background-color: ${getBackgroundColor(variant, theme, false)};

    ${theme.breakpoints.up('mobile')} {
      background-color: ${getBackgroundColor(variant, theme, true)};
    }
  `}
`;

export const ImageStyled = styled(Image)`
  flex-shrink: 0;
  margin-right: 8px;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-right: 12px;
  }
`;

export const TitleStyled = styled(Typography)`
  margin-bottom: 4px;
`;
